import React from 'react'
import { TransProps } from '@lingui/react'
import {getColor} from 'components/utils'


// Type
export type typeInputCheckbox = {
    variant?: string
    id: string
    name?: string
    label?: React.ReactElement<TransProps> | string
    defaultValue?: string | number
    value?: string | number
    defaultChecked?: boolean
    checked?: boolean
    required?: boolean
    disabled?: boolean
    labelClassName?: string,
    inputClassName?: string,

    readOnly?: boolean
    errorMessage?:  React.ReactNode
    onChange?: (e:React.ChangeEvent<HTMLInputElement>) => void
}


// Component
export const InputCheckbox:React.FC<typeInputCheckbox> = ({
    variant,
    id,
    name,
    label,
    defaultValue,
    value,
    defaultChecked,
    checked,
    required=false,
    disabled,
    labelClassName,
    inputClassName,

    onChange,
    readOnly,
    errorMessage,
}) => {

    const color = getColor(variant)
    const hasError = !!errorMessage

    const labelStyles = [`ml-2 block text-sm text-gray-${ disabled ? '400' : '900' }`, labelClassName].join(' ')
    const inputStyles = [`h-4 w-4 text-${color}-800 focus:ring-${color}-900 border-gray-300 rounded` , hasError ? 'border-red-500' : '', inputClassName].join(' ')

  return(
      <div className="flex flex-col gap-1">
          <div className="flex items-center">
              <input
                id={id}
                name={name}
                type="checkbox"
                required={required}
                disabled={disabled}
                defaultValue={defaultValue}
                value={value}
                defaultChecked={defaultChecked}
                checked={checked}
                onChange={onChange}
                readOnly={readOnly}
                className={inputStyles}
              />
              {label ? (
                <label htmlFor={id} className={labelStyles}>
                    {label}
                </label>
              ) : null}
          </div>
          {hasError && (
            <span className="text-red-500 text-sm">{errorMessage}</span>
          )}
      </div>
    )
}